exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeveloperInfo DL {\n  display: grid;\n  grid-template-columns: 110px auto; }\n  .DeveloperInfo DL DT {\n    text-align: right;\n    font-weight: bold; }\n", ""]);

// exports
